module.exports = __webpack_public_path__ + "images/sprites/ui/icon_check_og_cdde7c14687fe8439100cbb873936f35.png";